import { FC } from "react";
import { ChatMolecule, PlayersListMolecule } from "..";

import { ReadyButton } from "../../atoms";

const LobbyMain: FC<{}> = () => {

	return (
		<div className="lobby_main_wrapper" style={{ width: "100vw" }}>
			<div className="lobby_main">
				<div className="chat_wrapper" >
					<ChatMolecule shouldTheFirstMessageBeShown={true} />
				</div>

				<div className="space_between_chat_and_players_list"></div>

				<div className="players_wrapper">
					<PlayersListMolecule />

					<div className="ready_button_wrapper">
						<ReadyButton />
					</div>
				</div>
			</div>
		</div>
	);
};

export default LobbyMain;
